// src/components/Gallery/context.ts
import { createContext } from "react";
var GalleryContext = createContext({
  id: "",
  activeItem: 1,
  setActiveItem: () => {},
  totalItems: 1,
  setTotalItems: () => {},
  previousItem: 1
});
var GalleryNavigationContext = createContext({
  maxItems: 4,
  isNavExpanded: false,
  setIsNavExpanded: () => {},
  isNavExpandable: true
});
export { GalleryContext, GalleryNavigationContext };